/**
 * ログイン関係を扱うクラスです。
 * @class login.js
 * @constructor
 */
import { auth, customTokenSignIn } from "../../firebase/firebase";
    // トークンの前後の空白を除去// /home/user/ofc-dashboard-client/src/components/auth/Login.ts
    // ...
export const tokenLogin = (url: string): void => {
      const token: string = getParam("token", url).trim();
      console.log("ログイン試行中のURL:", url);
      if (token !== "") {
      customTokenSignIn(auth, token)
      .then((userCredential: any) => {
        console.log("ログイン成功:", userCredential);
      })
      .catch((error: any) => {
        console.error("Firebaseログインエラー:", error); // エラー全体をログに出力
        console.error("エラーを引き起こしたトークン:", token); // エラー時のトークンも再度ログに出力
      });
  } else {
    console.log("URL内にトークンが見つからないか、空です。");
  }
};

export const getParam = (name: string, url: string): string => {
  if (!url) url = window.location.href;
  name = name.replace(/[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return "";
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
